import { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { ChangesSavedLabelNotification } from '../../common'
import BigFutureAndConnectionsForm from './BigFutureAndConnectionsForm'

const mapStateToProps = state => {
  const { selectedOrgId } = state.user.data
  const orgSettings = state.settingsOrg[selectedOrgId]
  const { updated } = orgSettings || {}
  return { updated }
}

const changesSavedNotificationDisplayDuration = 500

const BigFutureAndConnectionsPanel = ({ updated }) => {
  const [saved, setSaved] = useState(false)
  const prevUpdated = useRef(updated)

  useEffect(() => {
    if (!prevUpdated.current && updated) {
      setSaved(true)
      setTimeout(() => {
        setSaved(false)
      }, changesSavedNotificationDisplayDuration)
    }
    prevUpdated.current = updated
  }, [updated])

  return (
    <div>
      <ChangesSavedLabelNotification
        in={saved}
        durationOut={1500}
        overrideDefaultStyle={{ float: 'right' }}
      />
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut
        labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
        laboris nisi ut aliquip ex ea commodo consequat.
      </p>
      <h4 style={{ textDecoration: 'none', fontWeight: 'bold' }}>Big Future School</h4>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut
        labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
        laboris nisi ut aliquip ex ea commodo consequat (&#34;AP Agreement&#34;).
      </p>
      <h4 style={{ textDecoration: 'none', fontWeight: 'bold' }}>Connections</h4>
      <p>
        Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
        pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt
        mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem
        accusantium doloremque laudantium.
      </p>
      <BigFutureAndConnectionsForm />
    </div>
  )
}

export default connect(mapStateToProps)(BigFutureAndConnectionsPanel)
